import { observable, action, computed } from 'mobx';
import {t} from 'shared/core';
import {DomainObject, oneOf} from 'shared/store';
import User from '../users/User'
import CompanyDocument from './CompanyDocument';

class NotificationRecipient extends DomainObject {
  @observable recipientType;
  @observable user;
  @observable companyDocument;

  @action merge(other) {
    super.merge(other, {
      user: User,
      companyDocument: CompanyDocument,
      recipientType: oneOf(['manager', 'specific_user'])
    });
  }

  @computed get value() {
    if (this.recipientType === 'specific_user') return this.user.id;

    return this.recipientType;
  }

  @computed get name() {
    if(this.recipientType === 'specific_user') return this.user.name;

    return t('models.company_document.notification_recipients.manager');
  }
}

export default NotificationRecipient;